import { render, staticRenderFns } from "./LinkLogin.vue?vue&type=template&id=966ea312&lang=pug"
import script from "./LinkLogin.vue?vue&type=script&lang=js"
export * from "./LinkLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateTimeInput: require('/home/docker/code/frontend/components/DateTimeInput.vue').default})
